import { createGlobalStyle } from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { BS_MODAL_BACKDROP_ZINDEX } from 'modules/core/constants';

import { WindowBreakpoints } from '../enums/windowBreakpoints.enum';
import { ROBOTO_FONT_FAMILY, DEFAULT_FONT_SIZE } from './typography';

export const GlobalStyles = createGlobalStyle`
  html, body {
    font-family: ${ROBOTO_FONT_FAMILY};
    font-size: ${DEFAULT_FONT_SIZE};
  }

  body,
  .modal-backdrop {
    --bs-backdrop-bg: ${COLORS.BLACK};
    --bs-backdrop-opacity: 0.4;
  }

  .adjust-deal-modal > .modal-content > .modal-body {
    padding: 0;
  }

  input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  body.ignore-dialog-padding {
    @media (max-width: 1050px) {
      padding-right: 0 !important;
    }
  }

  .modal.show {
    padding: 0 10px !important;
    scrollbar-gutter: stable;

    @media (max-width: ${WindowBreakpoints.small}px) {
      padding-left: 10px;
    }
  }

  @media (min-width: ${WindowBreakpoints.modalPageView + 1}px) {
    .modal-backdrop ~ .modal-backdrop {
      opacity: 0; 
      display: none;
    }
  }

  @media (max-width: ${WindowBreakpoints.modalPageView}px) {
    .adjust-deal-modal {
      margin-bottom: 0 !important;
      min-width: 958px !important;
      max-width: fit-content !important;
    }

    .adjust-deal-modal > .modal-content {
      margin-top: 42px;
      padding-left: 32px;
      border: 0;
    }

    .adjust-deal-modal. > .modal-content > .modal-body > .modal-header {
      padding-left: 5px;
      padding-right: 0;
    }

    .adjust-deal-modal > .modal-content > .modal-body > .modal-body {
      padding-left: 0;
      padding-right: 0;

      .card {
        margin-left: 10px;
      }
    }

    .adjust-deal-backdrop.show {
      opacity: 1;
      z-index: ${BS_MODAL_BACKDROP_ZINDEX - 3};

      margin-top: 42px;
      margin-left: 42px;
      background: ${COLORS.WHITE_5};
    }
  }

  .card-body {
    @media (max-width: ${WindowBreakpoints.small}px) {
      padding: 1rem;
    }
  }

  .accordion {
    max-width: 100%;
  }

  .rmsc {
    --rmsc-h: 32px;
    --rmsc-radius: .375rem;
    --rmsc-border: ${COLORS.GREY_32};
  }

  .rmsc.multi-select {
    @media (min-width: ${WindowBreakpoints.xxxLarge + 1}px) {
      max-width: 145px;
    }
  }

  .rmsc .dropdown-container {
    height: 25px;
  }

  .rmsc .dropdown-container:focus-within {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
  }

  .rmsc .dropdown-container[aria-disabled="true"],
  .input-group > select:disabled {
    background-color: ${COLORS.GREY_31};
    color: ${COLORS.GREY_21};
  }

  .rmsc .item-renderer {
    align-items: center;
  }

  .rmsc .gray {
    color: black;
  }

  .input-group-sm>.btn,
  .input-group-sm>.form-control,
  .input-group-sm>.form-select,
  .input-group-sm>.input-group-text {
    border-radius: .375rem;
  }
`;
